import { APIClient } from 'infra/APIClient'
import { APIConfig } from 'types/definitions'
import {
  CreateScopeWorkJobDto,
  OCRManualInputsDto,
  OCRManualInputsQuery,
  OCRScopeWorkSearchDto,
  OCRScopeWorkSearchQuery,
  AggregationResponseDto,
  LinkManuallyScopeWorkJobDto,
} from './dtos/ocr-scope-work'

export interface WunderAPI {
  ocrScopeWork: OCRScopeWorkAPI
}

export function createWunderAPI(opts: APIConfig): WunderAPI {
  return {
    ocrScopeWork: new OCRScopeWorkAPI(opts),
  }
}

export class OCRScopeWorkAPI extends APIClient {
  search(data: OCRScopeWorkSearchQuery): Promise<OCRScopeWorkSearchDto> {
    return this.client
      .get(`/v1/scope-work/search`, { params: data })
      .then(this._data)
  }

  aggregations(workspaceId: string): Promise<AggregationResponseDto> {
    return this.client
      .get(`/v1/scope-work/aggregations`, {
        params: { workspace_id: workspaceId },
      })
      .then(this._data)
  }

  manualInputs(data: OCRManualInputsQuery): Promise<OCRManualInputsDto> {
    return this.client
      .get(`/v1/scope-work/manual-inputs`, { params: data })
      .then(this._data)
  }

  scopeWork(data: CreateScopeWorkJobDto): Promise<void> {
    const body = new FormData()
    const { files, ...rest } = data
    body.append('meta', JSON.stringify({ ...rest }))

    files.forEach((f, i) =>
      body.append(`file${i + 1}`, f, sanitizeFileName(f.name))
    )

    return this.client.post(`/v1/scope-work`, body).then(this._data)
  }

  archive(scopeWorkId: string): Promise<void> {
    return this.client.delete(`/v1/scope-work/${scopeWorkId}`).then(this._data)
  }

  rerun(scopeWorkId: string): Promise<void> {
    return this.client
      .post(`/v1/scope-work/${scopeWorkId}/rerun`)
      .then(this._data)
  }

  linkManually(
    scopeWorkId: string,
    data: LinkManuallyScopeWorkJobDto
  ): Promise<void> {
    return this.client
      .post(`/v1/scope-work/${scopeWorkId}/manual`, data)
      .then(this._data)
  }

  review(scopeWorkId: string): Promise<void> {
    return this.client
      .post(`/v1/scope-work/${scopeWorkId}/review`)
      .then(this._data)
  }
}

/**
 * Sanitizes a file name.
 * @param {string} str
 */
function sanitizeFileName(str: string) {
  return str.replace(/\//g, '_').replace(/\\/g, '_')
}
